import { Box, Typography, Grid, Paper } from '@mui/material';
import { keyframes } from '@mui/system';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import BarChartIcon from '@mui/icons-material/BarChart';
import GroupsIcon from '@mui/icons-material/Groups';
import VideocamIcon from '@mui/icons-material/Videocam';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

const fadeIn = keyframes`
  from { opacity:0; transform:translateY(30px); }
  to   { opacity:1; transform:translateY(0); }
`;

const features = [
  { icon: <TrackChangesIcon sx={{ fontSize: 36 }} />, title: 'Suivi des Talents', desc: 'Profils détaillés, historique de performances et évolution physique de chaque joueur.' },
  { icon: <EmojiEventsIcon sx={{ fontSize: 36 }} />, title: 'Gestion de Tournois', desc: 'Planifiez, organisez et gérez vos compétitions avec tableaux, poules et classements.' },
  { icon: <BarChartIcon sx={{ fontSize: 36 }} />, title: 'Statistiques Avancées', desc: "Tableaux de bord interactifs, heatmaps et analyses tactiques en temps réel." },
  { icon: <GroupsIcon sx={{ fontSize: 36 }} />, title: 'Gestion des Équipes', desc: 'Gérez effectifs, compositions et rôles pour chaque club ou académie.' },
  { icon: <VideocamIcon sx={{ fontSize: 36 }} />, title: 'Analyse Vidéo', desc: 'Importez des clips, annotez les actions clés et partagez avec votre staff.' },
  { icon: <NotificationsActiveIcon sx={{ fontSize: 36 }} />, title: 'Alertes & Rapports', desc: 'Recevez des rapports automatisés et des alertes sur les performances des joueurs.' },
];

const Features = () => (
  <Box sx={{ py: 12, px: 3, bgcolor: '#ffffff' }}>
    <Typography variant="overline" sx={{
      letterSpacing: 4, display: 'block', textAlign: 'center', mb: 1,
      background: 'linear-gradient(135deg, #16a34a, #22c55e)',
      WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
      fontWeight: 700,
    }}>
      Fonctionnalités
    </Typography>
    <Typography variant="h2" sx={{
      textAlign: 'center', fontWeight: 800, mb: 8,
      fontSize: { xs: '2rem', md: '3rem' }, color: '#0f172a',
    }}>
      Tout ce dont vous avez besoin
    </Typography>

    <Grid container spacing={3} maxWidth={1100} mx="auto">
      {features.map((f, i) => (
        <Grid item xs={12} sm={6} md={4} key={i}>
          <Paper elevation={0} sx={{
            p: 4, height: '100%',
            bgcolor: '#f8fafc',
            border: '1px solid rgba(34,197,94,.12)',
            borderRadius: 3,
            animation: `${fadeIn} .7s ease forwards`,
            animationDelay: `${i * .1}s`,
            opacity: 0,
            transition: 'all .3s',
            '&:hover': {
              border: '1px solid rgba(34,197,94,.4)',
              bgcolor: 'rgba(34,197,94,.04)',
              transform: 'translateY(-6px)',
              boxShadow: '0 12px 32px rgba(34,197,94,.1)',
            },
          }}>
            <Box sx={{
              display: 'inline-flex', p: 1.2, borderRadius: 2, mb: 2,
              background: 'linear-gradient(135deg, rgba(34,197,94,.12), rgba(22,163,74,.08))',
              color: '#16a34a',
            }}>
              {f.icon}
            </Box>
            <Typography variant="h6" sx={{ color: '#0f172a', fontWeight: 700, mb: 1 }}>{f.title}</Typography>
            <Typography variant="body2" sx={{ color: '#64748b', lineHeight: 1.8 }}>{f.desc}</Typography>
          </Paper>
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default Features;